"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriggerConditions = void 0;
const __1 = require("../../");
const TriggerConditions = {};
exports.TriggerConditions = TriggerConditions;
TriggerConditions[__1.Triggers.TurnStartTrigger] = (card, player, game, event) => {
    let condition = true;
    if (card.trigger && card.trigger.condition.player === 'SELF')
        condition = player.user.id === event.player.user.id;
    return condition;
};
TriggerConditions[__1.Triggers.TurnEndTrigger] =
    TriggerConditions[__1.Triggers.TurnStartTrigger];
